import Header from 'components/Header';
import PrivacyData from 'data/Privacy';
import React from 'react';

export default function Privacy() {
  return (
    <div className="">
      <Header />

      <main className="main PrivacyPage">
        <div className="wrapper">
          <section className="section">
            <div className="section-intro">
              <div className="title">
                <h2>PRIVACY POLICY</h2>
                <br />
                <h2>VERSION 1.6, UPDATED JULY 2021</h2>
                <br />
              </div>
              <p className="body">
                Raven Livestream is a monetized livestreaming platform for
                organizations and individuals who want to host events online
                (“Events”) and publish live content. Raven Livestream
                Technologies (&quot;us&quot;, &quot;we&quot;, or
                &quot;our&quot;) operates http://www.ravenlivestream.com (the
                &quot;Site&quot;). This page in forms you of our policies
                regarding the collection, use and disclosure of Personal
                Information we receive from users of the Site. We use your
                Personal Information only for providing and improving the Site.
                By using the Site, you agree to the collection and use of
                information in accordance with this policy.
              </p>
            </div>

            <div className="privacies">
              {PrivacyData.map(({ title, content, details }) => (
                <div className="privacy-card" key={title}>
                  <h3>{title}</h3>
                  <p>{content}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
